var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{musicshow:_vm.muiscIsPlay},attrs:{"id":"music"},on:{"click":_vm.musicSwitch}},[_c('audio',{attrs:{"loop":"","autoplay":"autoplay","src":"https://t.shundecity.com/bjls2021/Home/View/index/music/bgm.mp3","id":"musicplay"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f60fad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/music.vue
// module id = null
// module chunks = 